import React from 'react'
import styled from 'styled-components'

import MetricInfoHeaderList from 'pages/shared/MaintenanceTrend/MetricInfoHeaderList'
import TrendMetricsOverview from 'pages/shared/MaintenanceTrend/TrendMetricsOverview'

import CollapsiblePanel from 'components/CollapsiblePanel'

import GA4 from 'helpers/ga4'

import { color } from 'styles/colors'

import { DeviceMaintenanceTrendGroup, DeviceMetric } from 'types/DeviceMetric'

type Props = {
  metricAndGroupList: Array<DeviceMaintenanceTrendGroup | DeviceMetric>
  showMetricSelection: boolean
  selectedMetrics: string[],
  handleMetricSelection: (metricName: string) => void
  deviceId: string
  trendName: string
  sendAnalyticsEvents: boolean
}

const TrendOverviewCard = ({
  metricAndGroupList,
  showMetricSelection,
  selectedMetrics,
  handleMetricSelection,
  deviceId,
  trendName,
  sendAnalyticsEvents
}: Props) => {
  const sendGA4Event = (action: string) => {
    if (sendAnalyticsEvents) {
      GA4.sendEvent({
        category: 'Customer Detail Page',
        action: 'Maintenance Trend Resize',
        label: `${deviceId}, ${trendName}, ${action}`
      })
    }
  }

  return (
    <S.CollapsiblePanel
      caretVerticalPosition="start"
      open
      expandedCallback={() => sendGA4Event('Expand')}
      collapsedCallback={() => sendGA4Event('Minimize')}
      headerComponent={
        <MetricInfoHeaderList
          {...{
            metricAndGroupList,
            showMetricSelection,
            selectedMetrics,
            handleMetricSelection
          }}
        />
      }
    >
      <TrendMetricsOverview {...{ metricAndGroupList }} />
    </S.CollapsiblePanel>

  )
}

export default TrendOverviewCard

const S = {
  CollapsiblePanel: styled(CollapsiblePanel)`
    background: ${color('paneBackground')};
    padding: 10px;
  `
}
